module.exports = __webpack_public_path__ + "static/media/ImageFour.f0629057.jpg";